export default __webpack_public_path__ + "static/media/upload-icon.7741fec8.svg";